<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="p-3">
            <h2 class="mb-5">Add FAQ Category</h2>
            <ElementCategories category_id="6" elementName="FAQ"></ElementCategories>
        </div>
    </div>
</template>

<script>
import ElementCategories from "@/components/ElementComponents/ElementCategories";

export default {
    components: {
        ElementCategories,
    },
    methods: {},
    data() {
        return {
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'FAQs',
                    to:'/faqs/all'
                }, {
                    text: 'FAQ Category',
                    href: '#'
                }
            ],
        }
    }
};
</script>
